<template>
  <div id="home_header" class="header_pc_only">
   
    <span v-on:click="home()" style="cursor:pointer">
      <img id="vy-logo" src="../../images/logo.png" alt="ボラ活エール" style="height:90px;width:auto" />
    </span>
    <div id="header_link">

      <span v-on:click="condition()" style="cursor:pointer">
        利用規約
      </span>
      <span v-on:click="policy()" style="cursor:pointer">
        プライバシーポリシー
      </span>
    </div>
  </div>

</template>

<script setup>
/* eslint-disable */

import { useStore } from 'vuex'
import { useRouter,useRoute } from 'vue-router'

/* 変数の記述 */
const store = useStore()
let router = useRouter()

let home = function(){
  let set_path = "/"

  if(store.state.access_shakyo != ""){
    set_path = set_path +store.state.access_shakyo+"/Taiken"
  }

  router.push(set_path)
}

let ichiran = function(){
  router.push("/Ichiran")
}

let policy = function(){
  router.push("/Policy")
}

let condition = function(){
  router.push("/Condition")
}


</script>

<style scoped>
/* HOMEヘッダー */
#home_header {
  width: 100%;
  background-color: #E7E7E7;
  height: 100px;
  padding: 10px;
}

  #header_link{
    width: 40%;
    font-size: 17px;
    display: flex;
    justify-content:space-around
  }
  #header_link span{
    color:black
  }

  @media screen and (min-width: 971px) {
  /* PC */
  #home_header{
    display: flex;
    align-items: center;
    justify-content:space-between
  }

  
}

@media screen and (max-width: 970px) {
/* スマホ */
  #home_header{
    display: none
  }

}
</style>
